class MegaMenue {

  constructor(selector) {
    this.selector = selector;

    this.class = {
      default: 'mm-default',
      multi: 'mm-multi',
      active: 'mm-active',
      banner: 'mm-banner',
      subitems: 'mm-subitems',
      columns: 'col-3'
    }

    this.type = {
      auto: 'auto',
      category: 'auto_category',
      manual: 'manual'
    }

    this.attribute = {
      banner: 'data-banner',
      bannerText: 'data-banner-text',
      bannerLink: 'data-banner-link'
    }

    this.state = {
      active: 0
    }

    this.init();
  }

  mouseOverActive(root) {
    const subs = root.querySelectorAll('.level_3 > li.submenu');

    subs.forEach((sub, i) => {
      if(i === 0) {
        this.state.active = i;
        subs[i].classList.add(this.class.active);
      }

      sub.addEventListener('mouseover', () => {
        if(i != this.state.active) {
          subs[this.state.active].classList.remove(this.class.active);
          subs[i].classList.add(this.class.active);
          this.state.active = i;
        }
      });
    });
  }

  setBanner(root) {
    const subitemBanners = root.querySelectorAll('.level_3 .submenu');

    subitemBanners.forEach((item) => {
      if(item.querySelector('.banner')) {
        item.classList.add(this.class.banner);
      }
    });
  }

  calcLevelMinHeight(root) {
    const container = root.querySelector('ul');

    if(!container) {
      return;
    }

    const containerStyles = getComputedStyle(container);
    const indicator = root.querySelectorAll('.level_4');
    const bannerMinHeight = 320;

    // add display block to container before get height
    container.style.display = 'block';

    let minHeight = container.offsetHeight;

    if(container.querySelector('.level_3 .banner') && container.offsetHeight < bannerMinHeight) {
      minHeight = bannerMinHeight;
    }

    indicator.forEach((element) => {
      const calcHeight = element.offsetHeight + parseInt(containerStyles.paddingTop) + parseInt(containerStyles.paddingTop);

      if(calcHeight > minHeight) {
        minHeight = calcHeight;
      }
    });

    container.style.minHeight = minHeight + 'px';

    // remove display block after get height
    container.style.display = '';
  }

  setDefaultMenue(element) {
    element.classList.add(this.class.default);
  }

  setCategoryMenue(element) {
    element.classList.add(this.class.multi);

    const elementLevelSubmenu = element.querySelectorAll('.level_3 .submenu');
    const hasLevel4 = element.querySelector('.level_3 .level_4');
    const hasBanner = element.querySelector('.level_3 .banner');
    const hasNavBreak = element.querySelector('.level_3 [data-break]');

    if(elementLevelSubmenu.length >= 1) {
      element.querySelector('.level_2 > li').classList.add(this.class.subitems);

      if(hasLevel4 && hasBanner) {
        element.querySelector('.level_2 > li').classList.add(this.class.columns);
        this.setBanner(element);
      } else if(!hasLevel4 && hasBanner) {
        this.setBanner(element);
      } else if(hasNavBreak) {
        element.querySelector('.level_2 > li').classList.add(this.class.columns);
      }
    }

    this.calcLevelMinHeight(element);
    this.mouseOverActive(element);
  }

  menueTypeHandler(menues) {
    menues.forEach((menue) => {
      const checkSubMenu = menue.querySelector('.level_2');

      if(checkSubMenu) {
        const getType = checkSubMenu.getAttribute('data-type');

        switch (getType) {
          case this.type.auto:
            this.setDefaultMenue(menue);
            break;
          case this.type.category:
            this.setCategoryMenue(menue);
            break;
          case this.type.manual:
            this.setDefaultMenue(menue);
            break;
          default:
            this.setDefaultMenue(menue);
        }
      }
    });
  }

  init() {
    if(!this.selector) {
      return;
    }

    this.menueTypeHandler(document.querySelectorAll(this.selector));
  }

}

export default MegaMenue;
